module.exports = __webpack_public_path__ + "amcharts/images/eraserIcon.png";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=amcharts/images/[name].[ext]!./~/amstock3/amcharts/images/eraserIcon.png
// module id = 263
// module chunks = 0